import { READ_ONLY_GET } from './actions.type';

import { WINDOW_API_ERROR_SHOW } from './mutations.type';

import { Api as ApiReadOnly } from '../api/api-tylko-do-odczytu';

const initialState = {
  readOnly: false,
  readOnlyMessage: undefined,
  readOnlyVerified: false
};

const readOnlyApi = new ApiReadOnly();

export const state = Object.assign({}, initialState);

export const actions = {
  async [READ_ONLY_GET](context) {
    try {
      let response = (
        await readOnlyApi.getReadOnly({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null
        })
      ).body;

      state.readOnlyMessage = response.message;
      state.readOnly = response.read_only;
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
    } finally {
      state.readOnlyVerified = true;
    }
  }
};

const getters = {
  readOnly: state => state.readOnly,
  readOnlyMessage: state => state.readOnlyMessage,
  readOnlyVerified: state => state.readOnlyVerified
};

export default {
  state,
  actions,
  getters
};
